import { toast } from '@mx/vix';
import { compareVersion } from '@mx/util';
import { normalizeError } from '@mx/pay-common';
import { CallbackPayResultSource, CreditType, env, monitor, signResultPage } from '@/common';
import { showResultPage } from './showResultPage';
import { deferIndependenceSignSuccess } from './callbackNativeRouter';

export function callbackSignResult(params: string) {
  monitor.captureResourceInfoMessage(`[info]callbackSignResult 执行来源: ${params}`);
  deferIndependenceSignSuccess();
}

/**
 * 签约结果页面数据及展示
 */
export function getSignResultPage() {
  signResultPage({
    scorePlanId: env.coreBusinessParams.scorePlanId,
    signScene: CreditType.PayDefer,
    token: env.commonParams.token,
  })
    .then((data) => {
      toast.hide();
      // SDK 9.3.0 以下，独立签约页面无法关闭，此处不打开支付后半页，直接回调业务方，走 catch 的逻辑
      if (compareVersion(env.commonParams.sdk_version, '9.3.0') < 0) {
        throw new Error('版本过低无法展示签约成功弹窗');
      }
      showResultPage(data.sign_result_page, callbackSignResult);
    })
    .catch((error) => {
      toast.show('text', '先用后付开启成功');
      setTimeout(() => {
        // 支付后弹窗请求异常，但是此时已经签约成功，通知成功，但是此处需要上报异常。
        callbackSignResult(CallbackPayResultSource.independenceResultFail);
        monitor.captureAjaxErrorMessage('[api]签约结果页面接口请求失败，用户无法打开支付后半页', {
          error: normalizeError(error),
        });
      }, 3000);
    });
}
